module.exports = __webpack_public_path__ + "static/predictivepoem 43-01-cf32b3055753abe09ae4036366afbbfd.jpg";